import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faChevronDown,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import dogFace from "../../assets/images/icon/dogFace.svg";
import catFace from "../../assets/images/icon/catFace.svg";
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import calendar from "../../assets/images/icon/calendar.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DogPaw from "../../assets/images/icon/DogPaw";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from "../../components/layout/TopBanner";
import { useNavigate } from "react-router-dom";
import dogHeart from "../../assets/images/dogbook/dog-heart.png";
import CustomPopup from "../../components/popup/CustomPopup";
import {
  postCreatePet,
  SearchDogBreed,
  SearchFavoriteProduct,
  SearchPetDetail,
} from "../../services/Dogbook";
// import { tempLineId1 } from "../../services/Api";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchId } from "../../services/SearchId";
import { useLiff } from "react-liff";
import TopLogo from "../../components/layout/TopLogo";
import helper from "../../functions/helper";
import dayjs from "dayjs";
import AddCatDetail from "./AddCatDetail";
import AddDogDetail from "./AddDogDetail";

const initialInputValues = {
  urlPicture: null,
  memberId: "",
  petName: "",
  dogBreedId: "",
  birthday: null,
  weight: "",
  favoriteProductId: "",
  isNoti: false,
  lastDateProduct: null,
  openSlide: true,
};

const initialErrorInput = {
  urlPicture: false,
  memberId: false,
  petName: false,
  dogBreedId: false,
  birthday: false,
  weight: false,
  favoriteProductId: false,
  lastDateProduct: false,
};

export default function AddDog() {
  const [isAdded, setIsAdded] = useState(false);
  const navigate = useNavigate();

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [memberId, setMemberId] = React.useState(null);
  const [petType, setPetType] = React.useState('dog');

  //api data
  const [dogBreedData, setDogBreedData] = useState([]);
  const [favProductData, setFavProductData] = useState([]);

  const [userInputs, setUserInputs] = useState([{ ...initialInputValues }]);
  const [errorInputs, setErrorInputs] = useState([{ ...initialErrorInput }]);
  let [petDetail, setPetDetail] = useState([]);

  const addDogForm = () => {
    setUserInputs([...userInputs, { ...initialInputValues }]);
    setErrorInputs([...errorInputs, { ...initialErrorInput }]);
  };

  const removeDogForm = (index) => {
    const userInputList = [...userInputs];
    const errorInputList = [...errorInputs];

    userInputList.splice(index, 1);
    errorInputList.splice(index, 1);

    setUserInputs(userInputList);
    setErrorInputs(errorInputList);
  };

  const handleUserInputChange = (
    event,
    index,
    fieldName = null,
    newValue = null
  ) => {
    let { name, value } = event?.target ?? { name: fieldName, value: newValue };
        const updatedUserInputs = [...userInputs];
        const updatedErrorInputs = [...errorInputs];
        updatedUserInputs[index][name] = value;
        updatedErrorInputs[index][name] = value ? false : true;

        setUserInputs(updatedUserInputs);
        setErrorInputs(updatedErrorInputs)
  };

  const toggleOpenSlide = (value, index) => {
    const updatedUserInputs = [...userInputs];
    updatedUserInputs[index]["openSlide"] = value;

    setUserInputs(updatedUserInputs);
  };

  function validateInputs() {
    let valid = true;
    let updatedErrors = [];
    for (var index = 0; index < userInputs.length; index++) {
      let updatedError = {
        // urlPicture: userInputs[index].urlPicture !== null ? false : true,
        petName: userInputs[index].petName !== "" ? false : true,
        dogBreedId: userInputs[index].dogBreedId !== "" ? false : true,
        birthday: userInputs[index].birthday !== null ? false : true,
        weight: userInputs[index].weight !== "" ? false : true,
        favoriteProductId:
          userInputs[index].favoriteProductId !== "" ? false : true,
        lastDateProduct:
          userInputs[index].lastDateProduct !== null ? false : true,
      };
      updatedErrors.push(updatedError);
      valid = !Object.values(updatedError).some((field) => field);
    }

    setErrorInputs(updatedErrors);

    return valid;
  }

  useEffect(() => {
    getSearchId();
    //
  }, []);

  async function getSearchId() {
    return await SearchId({
      params: { lineId: lineId || null },
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          window.location.replace("/register");
        } else {
          getPetDetail(response.data.body.memberId);
          setMemberId(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getPetDetail(member_id) {
    return await SearchPetDetail({
      params: { lineId: lineId || null },
      member_id: member_id,
    })
      .then(async (response) => {
        if (response.data.resultCode === 20000) {
          setPetDetail(response.data.body);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  return (
    <div id="adddog-page">
      <CustomPopup
        title={"ยกเลิกการเพิ่มน้องหมา"}
        desc={
          "คุณกำลังยกเลิกการเพิ่มข้อมูลของน้องหมาตัวใหม่ หากกด ยืนยัน แล้วข้อมูลของน้องหมาจะไม่ถูกบันทึก"
        }
        actionText = "ยืนยัน"
        cancelFunction={() => {
          setOpenCancelPopup(false);
        }}
        actionFunction={() => {
          navigate(-1);
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      />

      <div>
        <TopLogo />
        <TopBanner type="dogbookAdd" />
        <div
          id="add-btn" className="flex justify-center bg-white px-[20px] pt-[16px] pb-[24px] mx-[20px]"
        >
          <button
            onClick={() => setPetType('dog')}
            className={petType === 'dog' ? 'dogBookAddBtnActive' : 'dogBookAddBtn'}
            style={{ marginRight: "5px" }}
          >
            <p className="text-[16px] text-center mt-[-2px]">
              เพิ่มน้องหมา
            </p>
          </button>
          <button
            onClick={() => setPetType('cat')}
            className={petType === 'cat' ? 'dogBookAddBtnActive' : 'dogBookAddBtn'}
          >
            <p className="text-[16px] text-center  mt-[-2px]">
              เพิ่มน้องแมว
            </p>
          </button>
        </div>
        {petType === 'dog' ? <AddDogDetail></AddDogDetail> :
          <AddCatDetail></AddCatDetail>
        }

      </div>

    </div>
  );
}
